<template>
  <div></div>
</template>
<script>
import helpers from "@/helpers"
import pdfmake from "pdfmake"
import pdffonts from "pdfmake/build/vfs_fonts.js"

export default {
  data() {
    return {
      data: [],
      products: []
    }
  },
  methods: {
    generate(filters) {
      this.products = []
      this.filters = filters
      this.helpers = helpers

      if (!pdfmake.vfs) {
        pdfmake.vfs = pdffonts.pdfMake.vfs;
      }

      if (!this.filterProducts()) {
        return false
      }
      this.fixVarsToTable()
      this.makePDF()
      return true
    },
    filterProducts() {
      let products = this.$store.state.products
      if (this.filters.codigo.length)
        products = products.filter(product => this.filters.codigo.includes(product.codigo))
      if (this.filters.marca.length)
        products = products.filter(product => this.filters.marca.includes(product.marca))
      if (this.filters.modelo.length)
        products = products.filter(product => this.filters.modelo.includes(product.modelo))

      this.data = products
      return products.length
    },
    fixVarsToTable() {
      for (const product of this.data) {
        this.products.push([
          product.codigo,
          product.descricaoEN,
          product.marca,
          product.modelo,
          product.estoqueRegnaparts,
          product.estoqueRegnapartsReservado,
          '',
          '',
          product.estoqueRevestebem,
          product.estoqueRevestebemReservado,
          '',
          '',
          product.estoqueRegnaparts +
          product.estoqueRevestebem +
          product.estoqueRegnapartsReservado +
          product.estoqueRevestebemReservado,
          '',
        ])
      }
    },
    makePDF() {
      let docDefinition = {
        info: {
          title: `RELATORIO - ESTOQUE`,
        },
        content: [{
            alignment: "center",
            text: 'Relatório de Estoque | Gerado em: ' + this.helpers.dateHelper.getDateTimePTBR(),
            bold: true,
            margin: [0, 0, 0, 10],
            fontSize: 12,
          },
          {
            table: {
              headerRows: 1,
              body: [
                [{
                    text: 'CÓDIGO',
                    bold: true
                  },
                  {
                    text: 'DESCRIÇÃO EN/US',
                    bold: true
                  },
                  {
                    text: 'MARCA',
                    bold: true
                  },
                  {
                    text: 'MODELO',
                    bold: true
                  },
                  {
                    text: 'REG. DISP.',
                    bold: true
                  },
                  {
                    text: 'REG. RESERV.',
                    bold: true
                  },
                  {
                    text: 'REG. CONT.',
                    bold: true
                  },
                  {
                    text: 'REG. VEND.',
                    bold: true
                  },
                  {
                    text: 'REV. DISP.',
                    bold: true
                  },
                  {
                    text: 'REV. RESERV.',
                    bold: true
                  },
                  {
                    text: 'REV. CONT.',
                    bold: true
                  },
                  {
                    text: 'REV. VEND.',
                    bold: true
                  },
                  {
                    text: 'TOTAL WEB',
                    bold: true
                  },
                  {
                    text: 'TOTAL CONT.',
                    bold: true
                  }
                ],
                ...this.products,
              ]
            },
          }
        ],
        defaultStyle: {
          fontSize: 8,
        },
        pageMargins: [20, 20],
        pageOrientation: 'landscape',
      }
      docDefinition = JSON.parse(JSON.stringify(docDefinition))
      pdfmake.createPdf(docDefinition).open()
    }
  },
}

</script>
